import { useQuery } from '@apollo/client';
import {
  ALL_MODULES,
  AsyncPropSelector,
  COMMON_CONSTANTS,
  T1,
  useProduct
} from '@nile/components';
import { AccountClient, GET_REQUESTERS_BY_CRITERIA } from '@nile/graphql';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Popover, Button, ButtonGroup } from '@superops/ui-design-system';
import {
  DropdownIndicator,
  formatGroupLabel,
  formatOptionLabel,
  IndicatorSeparator
} from '@nile/components';
import { Edit } from '@styled-icons/material/Edit';
import { cloneDeep } from 'lodash';
import Select from 'react-select';
import React, { useCallback, useState } from 'react';
import AsyncSelect from 'react-select/async';
import styled from 'styled-components';
import { EditIcon } from '@nile/components/src/Icons';

const Label = styled.div`
  text-align: left;
  margin-left: 10px;
  margin-top: 10px;
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
`;

const CField = styled.div`
  .editable-cell,
  .cell {
    flex-grow: 1;
    font-weight: bold;
  }
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
`;

const Tag = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

function AsyncMultiselectUser(props) {
  const {
    field,
    _ticket,
    defaultValue,
    updateSelection,
    inlineEdit,
    isMulti,
    params
  } = props;
  const { editable, parentField, dependantField, actions, accessor } = params;
  const ticket = _ticket;
  const value = defaultValue;
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);

  const updateSelectedField = (val) => {
    if (!val) {
      updateSelection(field, []);
    }
    updateSelection(field, val);
  };
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const [updatedValue, setUpdatedValue] = useState(value);
  const updateUpdatedValue = (val) => {
    if (!val) {
      setUpdatedValue([]);
    }
    setUpdatedValue(val);
  };

  const getQuery = (property) => {
    switch (property.name) {
      default:
        return GET_REQUESTERS_BY_CRITERIA;
    }
  };
  const getAsyncOptions = (property) => {
    return { client: AccountClient, query: getQuery(property) };
  };
  const displayVal = value ? value.map((el) => el.name).join(', ') : '';
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;
  function getOperands(attribute, args) {
    const operands = [
      {
        attribute: attribute || 'name',
        operator: 'startsWith',
        value: args.inputValue
      }
    ];
    if (isMSPProduct) {
      operands.push({
        attribute: 'associations.client.accountId',
        operator: 'is',
        value: props.client.accountId
      });
    } else {
      operands.push({
        attribute: 'associations.site.id',
        operator: 'is',
        value: _ticket?.site?.id
      });
    }
    return operands;
  }
  const fetchValues = async (client, query, args) => {
    console.log('fetching values', client, query, args);
    const attribute = 'name';
    const nameKey = 'getRequesterList';
    const res = await client.query({
      query: query,
      variables: {
        listInfo: {
          condition: {
            joinOperator: 'AND',
            operands: getOperands(attribute, args)
          }
        }
      }
    });
    const allOptions = res?.data?.[nameKey]
      ? res.data[nameKey].userList.map((el) => {
          return {
            name: `${el[attribute]}`,
            value: `${el[attribute]}`,
            label: `${el[attribute]}`,
            field: el
          };
        })
      : [];

    console.log(allOptions);
    return allOptions;
  };

  const getTag = () => {
    const loadOptions = (inputValue, callback) => {
      if (inputValue.length < 2) return callback([]);
      const asyncOptions = getAsyncOptions(field);
      fetchValues(asyncOptions.client, asyncOptions.query, {
        inputValue,
        field
      }).then((res) => {
        return callback(res);
      });
    };
    return (
      <Tag>
        <Label>{field.label || ''}</Label>
        <AsyncSelect
          isMulti
          cacheOptions
          classNamePrefix="value_selector"
          loadOptions={loadOptions}
          onChange={updateUpdatedValue}
          components={{ IndicatorSeparator, DropdownIndicator }}
          closeMenuOnScroll={(e) => {
            return (
              e.target &&
              e.target.classList &&
              !(e.target.classList.value.indexOf('menu-list') > -1)
            );
          }}
          defaultValue={defaultValue}
          name="valueselector"
          menuPortalTarget={document.body}
          menuPlacement="auto"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 })
          }}
          noOptionsMessage={(params) => {
            return params?.inputValue?.length < 2
              ? 'Type 2 or more characters to search'
              : 'No options';
          }}
        />
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedValue(value);
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                togglePopoverActive();
                updateSelectedField(updatedValue);
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </Tag>
    );
  };
  return !popoverActive ? (
    <CField>
      <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
        <div className="ellipsis" title={displayVal}>
          {displayVal || <DisabledTag>NA</DisabledTag>}
        </div>
        {editable && <div className="edit-actions">{activator}</div>}
      </Wrap>
    </CField>
  ) : (
    <CField>
      <Wrap className="editable-cell">
        <div className="ellipsis" title={displayVal}>
          {displayVal || <DisabledTag>NA</DisabledTag>}
        </div>
        <Popover
          activator={activator}
          active={popoverActive}
          onClose={() => {
            // togglePopoverActive()
          }}
        >
          {getTag()}
        </Popover>
      </Wrap>
    </CField>
  );
}

export default AsyncMultiselectUser;
